/* ═══════════════════════════════════════════════
   LACTATE TRAINING — LANDING PAGE JS
   Asset: assets/lactate-landing.js
═══════════════════════════════════════════════ */

(function () {
  'use strict';

  // ── Nav scroll ─────────────────────────────
  const nav = document.getElementById('lt-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('lt-scrolled', window.scrollY > 20);
    });
  }

  // ── Hamburger menu ─────────────────────────
  const ham     = document.getElementById('lt-ham');
  const mobNav  = document.getElementById('lt-mob-nav');
  if (ham && mobNav) {
    ham.addEventListener('click', () => mobNav.classList.toggle('lt-open'));
  }
  window.ltCloseNav = function () {
    if (mobNav) mobNav.classList.remove('lt-open');
  };

  // ── Scroll reveal ──────────────────────────
  const revEls = document.querySelectorAll('.lt-rev');
  if ('IntersectionObserver' in window && revEls.length) {
    const ro = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('lt-vis');
          ro.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    revEls.forEach((el) => ro.observe(el));
  } else {
    // Fallback: just show everything
    revEls.forEach((el) => el.classList.add('lt-vis'));
  }

  // ── How It Works steps ─────────────────────
  window.ltActivateStep = function (el) {
    document.querySelectorAll('.lt-step-col').forEach((s) => s.classList.remove('lt-active'));
    el.classList.add('lt-active');
  };

  // ── Testimonial slider ─────────────────────
  let tIdx = 0;
  const tTrack = document.getElementById('lt-testi-track');
  const tPrev  = document.getElementById('lt-tPrev');
  const tNext  = document.getElementById('lt-tNext');

  function ltGetVis() {
    return window.innerWidth <= 768 ? 1 : window.innerWidth <= 1100 ? 2 : 3;
  }
  function ltMoveTesti() {
    if (!tTrack || !tTrack.children.length) return;
    const cardW = tTrack.children[0].offsetWidth + 18;
    const max   = tTrack.children.length - ltGetVis();
    tIdx = Math.max(0, Math.min(tIdx, max));
    tTrack.style.transform = `translateX(-${tIdx * cardW}px)`;
  }
  if (tNext) tNext.addEventListener('click', () => { tIdx++; ltMoveTesti(); });
  if (tPrev) tPrev.addEventListener('click', () => { tIdx--; ltMoveTesti(); });
  window.addEventListener('resize', ltMoveTesti);

  // ── FAQ accordion ──────────────────────────
  window.ltToggleFaq = function (btn) {
    const answer = btn.nextElementSibling;
    const wasOpen = answer.classList.contains('lt-on');
    document.querySelectorAll('.lt-faq-a').forEach((a) => a.classList.remove('lt-on'));
    document.querySelectorAll('.lt-faq-q').forEach((q) => q.classList.remove('lt-on'));
    if (!wasOpen) {
      answer.classList.add('lt-on');
      btn.classList.add('lt-on');
    }
  };

  // ── Pricing toggle ─────────────────────────
  const proPrices   = { m: 9,  y: 6  };
  const coachPrices = { m: 29, y: 20 };

  window.ltSetP = function (mode) {
    const pmEl      = document.getElementById('lt-pm');
    const pyEl      = document.getElementById('lt-py');
    const proEl     = document.getElementById('lt-pro-p');
    const coachEl   = document.getElementById('lt-coach-p');
    if (pmEl)    pmEl.classList.toggle('lt-on',    mode === 'm');
    if (pyEl)    pyEl.classList.toggle('lt-on',    mode === 'y');
    if (proEl)   proEl.textContent   = proPrices[mode];
    if (coachEl) coachEl.textContent = coachPrices[mode];
  };

  // ── Hero ring animation ────────────────────
  let deg = 0;
  const ringEl = document.querySelector('.lt-ring');
  if (ringEl) {
    setInterval(() => {
      deg = (deg + 0.6) % 101;
      ringEl.style.background =
        `conic-gradient(var(--lt-lime) 0% ${deg}%, rgba(255,255,255,.08) ${deg}% 100%)`;
    }, 35);
  }

})();
